import { motion, AnimatePresence } from "framer-motion";
import { Warning } from "@phosphor-icons/react";

// In-scope confirm dialog (no portal → Promotion Center theme tokens apply).
export function ConfirmDialog({ open, title, description, confirmLabel, cancelLabel, onConfirm, onCancel, danger }) {
  return (
    <AnimatePresence>
      {open && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center p-4" data-testid="confirm-dialog">
          <motion.div
            className="absolute inset-0 bg-background/70 backdrop-blur-sm"
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            onClick={onCancel}
          />
          <motion.div
            className="relative w-full max-w-md rounded-lg border border-border bg-popover p-6 shadow-2xl"
            initial={{ opacity: 0, scale: 0.96, y: 8 }} animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.96 }} transition={{ duration: 0.18 }}
          >
            {danger && (
              <div className="mb-3 flex h-9 w-9 items-center justify-center rounded-full bg-destructive/15 text-destructive">
                <Warning size={18} weight="fill" />
              </div>
            )}
            <h3 className="text-lg font-medium tracking-tight">{title}</h3>
            {description && <p className="mt-1.5 text-sm text-muted-foreground">{description}</p>}
            <div className="mt-6 flex justify-end gap-2">
              <button
                onClick={onCancel}
                className="rounded-md border border-border px-3.5 py-2 text-sm font-medium transition-colors hover:bg-accent"
                data-testid="confirm-cancel"
              >
                {cancelLabel}
              </button>
              <button
                onClick={onConfirm}
                className={`rounded-md px-3.5 py-2 text-sm font-medium transition-opacity hover:opacity-90 ${
                  danger ? "bg-destructive text-destructive-foreground" : "bg-primary text-primary-foreground"
                }`}
                data-testid="confirm-ok"
              >
                {confirmLabel}
              </button>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
}
